import { INote, UUID, getToken } from "helpers";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";

// Define a service using a base URL and expected endpoints
export const noteApi = createApi({
  reducerPath: "noteApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/auth/user/note`,
    prepareHeaders: (headers) => {
      headers.set("authorization-token", getToken() || "");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    createNote: builder.mutation<any, { username: UUID; note: string }>({
      query: ({ username, note }) => ({
        url: `${username}`,
        method: "PUT",
        body: {
          note,
        },
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),

    getNotes: builder.query<INote[] | any, UUID>({
      query: (username) => ({
        url: `list/${username}`,
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),

    markAsDone: builder.mutation<any, { note_id: number; uuid: UUID }>({
      query: ({ note_id, uuid }) => ({
        url: "mark-as-done",
        method: "POST",
        body: {
          note_id,
          uuid,
        },
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useCreateNoteMutation,
  useGetNotesQuery,
  useLazyGetNotesQuery,
  useMarkAsDoneMutation,
  usePrefetch: useNoteApiPrefetch,
} = noteApi;
